import { Component, Input, OnInit } from "@angular/core";
import { FormField } from "@app/forms/models/detail/FormField";
import { CerrixEditorViewerComponent } from "@app/shared/components/cerrix-editor-viewer/cerrix-editor-viewer.component";

@Component({
    selector: "form-entry-info",
    templateUrl: "./form-entry-info.component.html",
    styleUrls: ["../../form-entry-field.component.scss"],
    imports: [CerrixEditorViewerComponent],
})
export class FormEntryInfoComponent implements OnInit {
    @Input() field: FormField;

    ngOnInit() {
        this.field.Required = false;
    }
}
